import { render, staticRenderFns } from "./contact-us-form.vue?vue&type=template&id=748f90d6&scoped=true"
import script from "./contact-us-form.vue?vue&type=script&lang=js"
export * from "./contact-us-form.vue?vue&type=script&lang=js"
import style0 from "./contact-us-form.vue?vue&type=style&index=0&id=748f90d6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "748f90d6",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VInput: require('/var/www/tubber-new/components/global/v/input.vue').default,VTel: require('/var/www/tubber-new/components/global/v/tel.vue').default,VTextarea: require('/var/www/tubber-new/components/global/v/textarea.vue').default,VButton: require('/var/www/tubber-new/components/global/v/button.vue').default})
